// COPIED from extensions/carrier-marks by scripts/sync-carrier-marks.mjs.
// Do not edit here — edit the extension, then run `npm run sync-carrier-marks`.
// Builds the option's second line from a resolved sentence and Shopify's
// translate() (buyer's checkout language, keys in ../locales/*.json).
// Pure: `translate(key, options)` is injected, so tests can drive it with the
// locale JSON directly and check English parity with the backend wording.

export function renderSentence(translate, sentence) {
  if (!sentence) return null;
  switch (sentence.kind) {
    case 'protected':
      return translate('protected');
    case 'split':
      return translate('split');
    case 'pickup':
    case 'locker':
      // The GLS logo and the "Pickup Point" title already say where it goes;
      // the sentence stays as short as the parcel rows so it fits one line
      // (Geoffrey, 2026-09-10).
      return sentence.parcels > 0
        ? translate('shippedAs', { parts: translate('parcels', { count: sentence.parcels }) })
        : translate('protected');
    case 'shipped': {
      const parts = [];
      if (sentence.parcels > 0) parts.push(translate('parcels', { count: sentence.parcels }));
      if (sentence.pallets > 0) parts.push(translate('pallets', { count: sentence.pallets }));
      if (!parts.length) return translate('protected');
      return translate('shippedAs', { parts: parts.join(translate('listSeparator')) });
    }
    default:
      return null;
  }
}

export function renderAlt(translate, resolved, carrierLabel) {
  if (resolved.pickup) return translate('altPickup');
  if (resolved.carrier && carrierLabel) return translate('altCarrier', { carrier: carrierLabel });
  if (resolved.mark === 'split') return translate('altSplit');
  if (resolved.mark === 'pallet') return translate('altPallet');
  return translate('altDelivery');
}
